<script setup>
import { useUserStore } from '@/stores/user';
import { getActivePinia } from 'pinia';
import { useRouter } from 'vue-router';
import UserAvatar from '@/components/navigation/UserAvatar.vue';
import { inject } from 'vue';

const user = useUserStore();
const router = useRouter();
const backendApi = inject('backendApi');

const logout = async () => {
    const acronym = user.data?.company?.acronym;
    try {
        await backendApi().auth().logout();
    } catch (e) {
        console.error('Error during logout', e);
    } finally {
        getActivePinia()._s.forEach((store) => store.$reset());

        if (acronym) {
            router.push({ path: `/${acronym}/login` });
        } else {
            router.push({ name: 'login' });
        }
    }
};
</script>

<style lang="scss" scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>
<template>
    <v-menu width="350px" rounded>
        <template v-slot:activator="{ props }">
            <v-btn icon v-bind="props" class="btn-show-user-card">
                <UserAvatar></UserAvatar>
            </v-btn>
        </template>
        <v-card>
            <v-card-text>
                <div class="d-flex justify-space-between mb-5">
                    <div>{{ user.data?.company?.name ?? '' }}</div>
                    <div @click="logout" class="cursor-pointer">
                        {{ $t('Log out') }}
                    </div>
                </div>
                <v-row align="center" no-gutters>
                    <v-col cols="auto" class="pe-3">
                        <UserAvatar size="20"></UserAvatar>
                    </v-col>
                    <v-col>
                        <h3>{{ user.data.user?.name }}</h3>
                        <p class="text-caption">{{ user.data.user?.email }}</p>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-menu>
</template>
